import.meta.glob("./behaviours/**/*.{js,hbs,jst.ejs}", { eager: true });

// Generic behaviours that can be attached to any element with a data-behaviour
// attribute
(function ($) {
  jQuery(function ($) {
    // BEHAVIORS

    // Allow clicks on links in forms to enable an associated input
    //   data-target: selector that matches the input to enable
    //   data-message: prompt the user to confirm the click with the given message
    addBehavior("enable-input", "click", function (event) {
      var target = jQuery(this).data("target");
      var message = jQuery(this).data("message");
      if (message && !confirm(message)) {
        return false;
      }

      var $target = jQuery(target);

      // The enabled input submits its own value from here on.
      document.querySelectorAll("[data-enable-input-copy]").forEach(function (copy) {
        if (copy.dataset.enableInputCopy === target) {
          copy.remove();
        }
      });

      // Check if the target is a select input
      if ($target.is("select")) {
        $target.prop("disabled", false).trigger("focus").trigger("change");
      } else {
        $target.removeAttr("disabled").trigger("focus");
      }

      // Rails pairs a disabled checkbox or multiple select with a disabled hidden input carrying the
      // unchecked or empty value. It must submit with the control again, or an unchecked box sends
      // no parameter and the attribute keeps its value.
      var names = Array.from(document.querySelectorAll(target), function (control) {
        return control.name;
      });
      document.querySelectorAll('input[type="hidden"]:disabled').forEach(function (hidden) {
        if (names.includes(hidden.name)) {
          hidden.disabled = false;
        }
      });

      event.preventDefault();
    }).each(function copyReadonlyInput() {
      // Create a copy of each enablable input and enable it so that if the value changed but the form failed to save,
      // this change won't be omitted even if the user doesn't re-enable the input by clicking override
      var target = this.dataset.target;
      var targets = document.querySelectorAll(target);
      var input = targets[0];
      // Skip adding hidden input if the input has data-no-hidden-input attribute
      if (!input || input.dataset.noHiddenInput) {
        return;
      }

      // The copy submits what the enabled input would: a checkbox its value only while checked
      // (otherwise the "0" its hidden partner carries), a multiple select one entry per selected
      // option, or the blank entry its hidden partner carries when nothing is selected, so a
      // cleared selection still reaches the server.
      var values;
      if (input.localName === "sp-select") {
        // Ready handlers can run before the custom element exposes its live value.
        const value = input.value ?? input.getAttribute("value");
        if (Array.isArray(value)) {
          values = value;
        } else if (input.hasAttribute("multiple")) {
          values = JSON.parse(value || "[]");
        } else {
          values = [value ?? ""];
        }
        if (values.length === 0) {
          values = [""];
        }
      } else if (input.type === "checkbox") {
        values = [input.checked ? input.value : "0"];
      } else if (input.matches("select[multiple]")) {
        values = Array.from(input.selectedOptions)
          .filter(function (option) {
            return !option.matches(":disabled");
          })
          .map(function (option) {
            return option.value;
          });
        if (values.length === 0) {
          values = [""];
        }
      } else {
        values = [input.value];
      }

      targets.forEach(function (element) {
        values.forEach(function (value) {
          var copy = document.createElement("input");
          copy.type = "hidden";
          copy.name = input.name ?? input.getAttribute("name");
          copy.dataset.enableInputCopy = target;
          copy.value = value;
          element.before(copy);
        });
      });
    });

    // HELPER FUNCTIONS

    function addBehavior(name, eventName, fn) {
      var selector = '[data-behaviour~="' + name + '"]';
      jQuery(document).on(eventName, selector, fn);
      return jQuery(selector);
    }

    function addTargetBehavior(name, eventName, targetDataAttrName, fn) {
      var selector = '[data-behaviour~="' + name + '"]';
      return jQuery(selector).each(function () {
        var self = this;
        var target = jQuery(jQuery(this).data(targetDataAttrName));

        target.on(eventName, function (event) {
          fn.call(self, event, target);
        });
      });
    }
  });
})(jQuery); // pass in jquery becasue prototype is also present
